import MuiDrawer from "@mui/material/Drawer";
import { Box, styled, IconButton, useTheme, Divider } from "@mui/material";
import { useNavigate } from "react-router";
import Logo from "../../../assets/Images/wf-nav-logo.png";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LeftNavbarLists from "../leftNavLists/leftNavbarLists";
import DrawerHeadBox from "../drawerHead/drawerHead";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});


const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const WebViewDrawer = ({ open, handleDrawerClose }) => {

  return (
    <>
      <Drawer variant="permanent" open={open}>
        <DrawerHeadBox handleDrawerClose={handleDrawerClose} />
        <Divider />
        <LeftNavbarLists open={open} />

      </Drawer>
    </>
  );
};
export default WebViewDrawer;
